import { userRoles, usersType } from './user'
import { getEncryptedItem } from '@/helpers'
import { can } from '@layouts/plugins/casl'

export const authUser = computed(() => getEncryptedItem('userData') ?? {})

export const isAdmin = computed(() => can('manage', 'all'))

export const isLoader = computed(() => getEncryptedItem('userData')?.role === usersType.loader)

export const isTrucker = computed(() => getEncryptedItem('userData')?.role === usersType.trucker)

export const isHybridUser = computed(() => getEncryptedItem('userData')?.role === usersType.hybridUsersDocType)

export const isAccountOperatorUser = computed(() => getEncryptedItem('userData')?.role === userRoles.accountOperator)

export const isOperator = computed(() => can('read-admin-dashboard', 'Operators'))

export const isAdminOrOperator = computed(() => can('manage', 'Operator'))

export const isLoadOperator = computed(() => can('manage', 'Loaders'))

export const isTruckerOperator = computed(() => can('manage', 'Truckers'))

export const isAccountsOperator = computed(() => can('manage', 'Accounts'))

export const isMangeLoader = computed(() => can('manage', 'Loader'))

export const isMangeTrucker = computed(() => can('manage', 'Trucker'))

export const isAddEditLoads = computed(() => can('read', 'Load'))

export const isAddEditOffers = computed(() => can('read', 'Offer'))

export const manageLoads = computed(() => can('manage', 'Load'))

export const canStatusUpdateHybridUsers = computed(() => can('manage', 'Hybrid Users'))

export const canUpdateHybridUsers = computed(() => can('update', 'Hybrid User Profile'))

export const canUpdateConfirmations = computed(() => isOperator.value)

export const adminOrOperators = [
  userRoles.loaderOperator,
  userRoles.truckerOperator,
  userRoles.accountOperator,
  userRoles.admin,
]

export const isAdminOrOperatorRole = computed(() => adminOrOperators.includes(getEncryptedItem('userData')?.role))
